import router from "./router";
import i18n from "./i18n";

export const accountsModuleRouter = router;
export const accountsModuleI18n = i18n;
